import { render, staticRenderFns } from "./islem.vue?vue&type=template&id=3c036a23&scoped=true"
import script from "./islem.vue?vue&type=script&lang=js"
export * from "./islem.vue?vue&type=script&lang=js"
import style0 from "./islem.vue?vue&type=style&index=0&id=3c036a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c036a23",
  null
  
)

export default component.exports